import Footer7 from './Footer7'
export default Footer7
